// RouteLink.js
import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";

// Lazy load components for code splitting
const LoginPage = React.lazy(() => import("./Pages/Login/LoginPage"));
const DashboardLayout = React.lazy(() => import("./Layout/DashboardLayout"));
const DashboardHome = React.lazy(
  () => import("./Pages/Dashboard/DashboardHome"),
);
const PrivateRoute = React.lazy(() => import("./Utilities/PrivateRoute"));

// News Components
const NewsList = React.lazy(() => import("./Pages/News/NewsList"));
const AddNews = React.lazy(() => import("./Pages/News/AddNews"));

// Gallery Components
const GalleryList = React.lazy(() => import("./Pages/Gallery/GalleryList"));
const AddGallery = React.lazy(() => import("./Pages/Gallery/AddGallery"));

// Blog Components
const BlogList = React.lazy(() => import("./Pages/Blog/BlogList"));
const AddBlog = React.lazy(() => import("./Pages/Blog/AddBlog"));

// PageSeo Components
const PageSeoList = React.lazy(() => import("./Pages/PageSeo/PageSeoList"));
const AddPageSeo = React.lazy(() => import("./Pages/PageSeo/AddPageSeo"));

// Enquiry Components
const EnquiryList = React.lazy(
  () => import("./Pages/Enquiries/EnquiryList"),
);
const EnquiryDetail = React.lazy(
  () => import("./Pages/Enquiries/EnquiryDetail"),
);

// Account Components
const ChangePassword = React.lazy(
  () => import("./Pages/Account/ChangePassword"),
);

const routes = [
  {
    path: "/login",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <PrivateRoute />
      </Suspense>
    ), // Wrap protected routes here
    children: [
      {
        path: "/dashboard",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <DashboardLayout />
          </Suspense>
        ),
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <DashboardHome />
              </Suspense>
            ),
          },
          {
            path: "news",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <NewsList />
              </Suspense>
            ),
          },
          {
            path: "newsadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddNews />
              </Suspense>
            ),
          },
          {
            path: "gallery",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <GalleryList />
              </Suspense>
            ),
          },
          {
            path: "galleryadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddGallery />
              </Suspense>
            ),
          },
          {
            path: "blog",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <BlogList />
              </Suspense>
            ),
          },
          {
            path: "blogadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddBlog />
              </Suspense>
            ),
          },
          {
            path: "pageseo",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <PageSeoList />
              </Suspense>
            ),
          },
          {
            path: "pageseoadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddPageSeo />
              </Suspense>
            ),
          },
          {
            path: "enquiries",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <EnquiryList />
              </Suspense>
            ),
          },
          {
            path: "enquirydetail",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <EnquiryDetail />
              </Suspense>
            ),
          },
          {
            path: "changepassword",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ChangePassword />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];

export default routes;
